<template>
    <BaseNotification role="status" aria-label="Voice input suggestion" theme="info" hide-dismiss class="w-full">
        <template #content>
            <div class="flex items-center gap-3">
                <BaseButton theme="primary" size="sm" icon-only aria-label="Switch to voice input" class="shrink-0 animate-mic-pulse" @click="emit('activate-voice')">
                    <i class="bi bi-mic-fill" aria-hidden="true"></i>
                </BaseButton>
                <p class="flex-1 body-small text-ink-muted">{{ content }}</p>
                <BaseButton theme="tertiary" size="sm" icon-only aria-label="Dismiss voice suggestion" @click="emit('dismiss')">
                    <i class="bi bi-x" aria-hidden="true"></i>
                </BaseButton>
            </div>
        </template>
    </BaseNotification>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";

defineProps<{
    content: string;
}>();

const emit = defineEmits<{
    dismiss: [];
    "activate-voice": [];
}>();
</script>

<style scoped>
@layer components {
    @media (prefers-reduced-motion: no-preference) {
        .animate-mic-pulse {
            animation: mic-pulse 2s ease-in-out 0.5s 3;
        }
    }
}

@keyframes mic-pulse {
    0%,
    100% {
        box-shadow: 0 0 0 0 color-mix(in srgb, var(--color-button-primary) 40%, transparent);
    }
    50% {
        box-shadow: 0 0 0 6px transparent;
    }
}
</style>
